import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS } from './utils'
import store from '@/store'

export default [
  {
    path: '/',
    name: 'Sinister',
    component: Layout,
    meta: {
      title: 'Siniestros',
      showInSidebar: true,
      icon: 'mdi-car',
      excludeGroup: EXTRANET_GROUPS,
      ifCan: {
        view: 'Sinister/sinister'
      }
    },
    children: [
      {
        path: '/siniestros/listado',
        name: 'Sinister List',
        component: () => import('@/pages/Sinister/List/index.vue'),
        meta: {
          title: 'Listado',
          showInSidebar: true,
          forceRefresh: true
        }
      },
      {
        path: '/siniestros/edicion/:id',
        name: 'Register Edition',
        props: true,
        component: () => import('@/pages/Sinister/Register/index.vue'),
        meta: {
          title: 'Registro',
          ifCan: {
            change: 'Sinister/sinister'
          }
        }
      },
      {
        path: '/siniestros/registro',
        name: 'Register New',
        component: () => import('@/pages/Sinister/Register/index.vue'),
        meta: {
          showInSidebar: true,
          title: 'Registro',
          ifCan: {
            add: 'Sinister/sinister'
          },
          excludeGroup: ['CoDi']
        }
      },
      {
        path: '/siniestros/reasignacion',
        name: 'Reassigment',
        component: () => import('@/pages/Sinister/Reassignment/index.vue'),
        meta: {
          showInSidebar: true,
          title: 'Reasignación de siniestros',
          ifCan: {
            add: 'Sinister/sinister'
          },
          excludeGroup: ['CoDi']
        }
      },
      {
        path: '/siniestros/:slug',
        name: 'File',
        props: true,
        component: () => import('@/pages/Sinister/File/index.vue'),
        meta: {
          showInSidebar: false,
          title: 'Ficha de siniestro'
        },
        beforeEnter: ({ params }, _, next) => {
          const isProvider = store.getters['account/userInGroup']('Proveedor')
          if (isProvider) {
            next({ name: 'File Provider', params })
          } else if (EXTRANET_GROUPS.some(g => store.getters['account/userInGroup'](g))) {
            next({ name: 'Extranet Sinister File', params })
          } else {
            next()
          }
        }
      },
      {
        path: '/siniestros_proveedor/:slug',
        name: 'File Provider',
        props: true,
        component: () => import('@/pages/Sinister/FileProvider/index.vue'),
        meta: {
          showInSidebar: false
        }
      },
      {
        path: '/siniestros/vista_impresion/:sinister',
        name: 'Preview Grid',
        props: true,
        component: () => import('@/pages/Sinister/File/PreviewGrid/index.vue'),
        meta: {
          showInSidebar: false
        }
      },
      {
        path: '/siniestros/archivo_afectado/:casualty',
        name: 'Affected File',
        props: true,
        component: () => import('@/pages/Sinister/File/PreviewGrid/KAffectedFile.vue'),
        meta: {
          showInSidebar: false
        }
      }
    ]
  }
]
